export default "__VITE_ASSET__y7_BfGcS__"